require("./payrollLoanRequestError.scss");

// @vendor
const React = require("react");
// @components
const WizardError = require("components/commons/wizardError/wizardError");
// @core
const { formatText, FormattedText } = require("core/i18n").i18n;
//@analytics
const {
    analyticsId,
    catalogue,
} = require("../analytics/payrollLoanRequestAnalytics");
//@utilities
const { recordPage } = require("utilities/tagging");

const PayrollLoanRequestError = () => {
    const errorTitle = formatText("payrollLoanRequestError-title");
    const mainButtonLabel = formatText(
        "payrollLoanRequestError-backTo"
    ).toUpperCase();
    const mainButtonConfig = {
        label: mainButtonLabel,
        url: "/myprofile/global",
    };

    React.useEffect(() => {
        recordPage(
            catalogue[analyticsId.PAYROLL_LOAN_REQUEST_WIZARD_ERROR]({
                errorMessage: errorTitle,
            })
        );
    }, []);

    return (
        <section className="col-xs-12 payroll-loan-request-error">
            <WizardError
                errorMessage={errorTitle}
                mainButton={mainButtonConfig}
            >
                <div className="payroll-loan-request-error__content">
                    <FormattedText
                        value="payrollLoanRequestError-message1"
                        className="payroll-loan-request-error__message"
                    />
                    <FormattedText value="payrollLoanRequestError-message2" />
                </div>
            </WizardError>
        </section>
    );
};

module.exports = PayrollLoanRequestError;
